import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-88a560bc")

_pushScopeId("data-v-88a560bc")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Авторизация", -1)
const _hoisted_2 = { class: "LoginForm__actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Забыли пароль? ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Войти ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_email = _resolveComponent("icon-email")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_password = _resolveComponent("icon-password")!
  const _component_s_password = _resolveComponent("s-password")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("form", {
    class: "LoginForm",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSignin && _ctx.emitSignin(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_s_input, {
      placeholder: "Логин",
      value: _ctx.credentialsState.login,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.credentialsState.login = $event))
    }, {
      icon: _withId(() => [
        _createVNode(_component_icon_email, { class: "icon-email" })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_s_password, {
      placeholder: "Пароль",
      value: _ctx.credentialsState.password,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.credentialsState.password = $event))
    }, {
      icon: _withId(() => [
        _createVNode(_component_icon_password, { class: "icon-password" })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_s_button, {
        class: "transparent",
        type: "button",
        onClick: _ctx.emitRestore
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_s_button, {
        class: "green",
        type: "submit",
        loading: _ctx.loading
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
})